
export class EsUserAccessibilityToService {
  userHasSpecialTypes: boolean;
  isUserAllowedToUseService: boolean;
  reasonAr: string;
  reasonEn: string;
  url: string;
}
